"use strict";

require("core-js/modules/es.function.name");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _native = _interopRequireDefault(require("@emotion/native"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactNative = require("react-native");

var _react = _interopRequireDefault(require("react"));

var _types = _interopRequireDefault(require("./types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var InvalidType = function InvalidType() {
  return _react["default"].createElement(_reactNative.Text, {
    style: {
      margin: 10
    }
  }, "Invalid Type");
};

var Label =
/*#__PURE__*/
_native["default"].Text(function (_ref) {
  var theme = _ref.theme;
  return {
    marginLeft: 10,
    fontSize: 14,
    color: theme.labelColor,
    fontWeight: 'bold'
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9Qcm9wRmllbGQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBUWMiLCJmaWxlIjoiLi4vc3JjL1Byb3BGaWVsZC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgeyBWaWV3LCBUZXh0IH0gZnJvbSAncmVhY3QtbmF0aXZlJztcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL25hdGl2ZSc7XG5pbXBvcnQgVHlwZU1hcCBmcm9tICcuL3R5cGVzJztcblxuY29uc3QgSW52YWxpZFR5cGUgPSAoKSA9PiA8VGV4dCBzdHlsZT17eyBtYXJnaW46IDEwIH19PkludmFsaWQgVHlwZTwvVGV4dD47XG5cbmNvbnN0IExhYmVsID0gc3R5bGVkLlRleHQoKHsgdGhlbWUgfSkgPT4gKHtcbiAgbWFyZ2luTGVmdDogMTAsXG4gIGZvbnRTaXplOiAxNCxcbiAgY29sb3I6IHRoZW1lLmxhYmVsQ29sb3IsXG4gIGZvbnRXZWlnaHQ6ICdib2xkJyxcbn0pKTtcblxuY29uc3QgUHJvcEZpZWxkID0gKHsgb25DaGFuZ2UsIG9uUHJlc3MsIGtub2IgfSkgPT4ge1xuICBjb25zdCBJbnB1dFR5cGUgPSBUeXBlTWFwW2tub2IudHlwZV0gfHwgSW52YWxpZFR5cGU7XG5cbiAgcmV0dXJuIChcbiAgICA8Vmlldz5cbiAgICAgIHsha25vYi5oaWRlTGFiZWwgPyA8TGFiZWw+e2Ake2tub2IubGFiZWwgfHwga25vYi5uYW1lfWB9PC9MYWJlbD4gOiBudWxsfVxuICAgICAgPElucHV0VHlwZSBrbm9iPXtrbm9ifSBvbkNoYW5nZT17b25DaGFuZ2V9IG9uUHJlc3M9e29uUHJlc3N9IC8+XG4gICAgPC9WaWV3PlxuICApO1xufTtcblxuUHJvcEZpZWxkLnByb3BUeXBlcyA9IHtcbiAga25vYjogUHJvcFR5cGVzLnNoYXBlKHtcbiAgICBuYW1lOiBQcm9wVHlwZXMuc3RyaW5nLFxuICAgIGxhYmVsOiBQcm9wVHlwZXMuc3RyaW5nLFxuICAgIHZhbHVlOiBQcm9wVHlwZXMuYW55LFxuICAgIGhpZGVMYWJlbDogUHJvcFR5cGVzLmJvb2wsXG4gICAgdHlwZTogUHJvcFR5cGVzLm9uZU9mKFtcbiAgICAgICd0ZXh0JyxcbiAgICAgICdudW1iZXInLFxuICAgICAgJ2NvbG9yJyxcbiAgICAgICdib29sZWFuJyxcbiAgICAgICdvYmplY3QnLFxuICAgICAgJ3NlbGVjdCcsXG4gICAgICAnYXJyYXknLFxuICAgICAgJ2RhdGUnLFxuICAgICAgJ2J1dHRvbicsXG4gICAgICAncmFkaW9zJyxcbiAgICBdKSxcbiAgfSkuaXNSZXF1aXJlZCxcbiAgb25DaGFuZ2U6IFByb3BUeXBlcy5mdW5jLmlzUmVxdWlyZWQsXG4gIG9uUHJlc3M6IFByb3BUeXBlcy5mdW5jLmlzUmVxdWlyZWQsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBQcm9wRmllbGQ7XG4iXX0= */");

var PropField = function PropField(_ref2) {
  var onChange = _ref2.onChange,
      onPress = _ref2.onPress,
      knob = _ref2.knob;
  var InputType = _types["default"][knob.type] || InvalidType;
  return _react["default"].createElement(_reactNative.View, null, !knob.hideLabel ? _react["default"].createElement(Label, null, "".concat(knob.label || knob.name)) : null, _react["default"].createElement(InputType, {
    knob: knob,
    onChange: onChange,
    onPress: onPress
  }));
};

PropField.propTypes = {
  knob: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    label: _propTypes["default"].string,
    value: _propTypes["default"].any,
    hideLabel: _propTypes["default"].bool,
    type: _propTypes["default"].oneOf(['text', 'number', 'color', 'boolean', 'object', 'select', 'array', 'date', 'button', 'radios'])
  }).isRequired,
  onChange: _propTypes["default"].func.isRequired,
  onPress: _propTypes["default"].func.isRequired
};
var _default = PropField;
exports["default"] = _default;